import { FormControl, FormHelperText, FormLabel } from '@mui/material'
import React, { Suspense } from 'react'
import { useController } from 'react-hook-form'

const MDEditor = React.lazy(() => import('@uiw/react-md-editor'))

type Props = {
  error?: boolean
  height?: number
  required?: boolean
  value?: string
  onChange: (value: string) => void
}

export const MarkDownEditor = ({ height = 400, required = false, value = '', onChange }: Props) => {
  const onLocalChange = (val?: string) => {
    onChange(val || '')
  }

  return (
    <Suspense fallback={<div>Loading editor...</div>}>
      <MDEditor
        value={value}
        onChange={onLocalChange}
        height={height}
        aria-required={required}
        data-color-mode="light"
        textareaProps={{ required }}
        preview="edit"
      />
    </Suspense>
  )
}

type ControlledProps = Omit<Props, 'value' | 'onChange'> & {
  label: string
  name: string
}

export const CMarkDownEditor = (props: ControlledProps) => {
  const { label, name, ...otherProps } = props
  const { field, fieldState } = useController({ name })

  return (
    <FormControl fullWidth error={!!fieldState.error} margin="normal" required={!!otherProps.required}>
      <FormLabel>{label}</FormLabel>
      <MarkDownEditor value={field.value} onChange={field.onChange} error={!!fieldState.error} {...otherProps} />
      <FormHelperText>{fieldState.error?.message}</FormHelperText>
    </FormControl>
  )
}
